import api from "../services/api";

export async function InsertScore(userid: any, category: any, points: any, title: any, type: any, gameid: any) {
  await api.post("/api/scores", { id: 0, userid, category, score: points, activity: title, type, scoredate: new Date() });
}
